type RetrieveListError = {
  notFound: boolean;
};

const retrieveListError: RetrieveListError = {
  notFound: false,
};

export type { RetrieveListError };

export { retrieveListError };
